import { FC, useCallback, useState } from "react"
import { occupationCategoryDeleteApi } from "src/domain/api/occupationCategory/occupationCategoryDeleteApi"
import { OccupationCategory } from "src/domain/entities/occupationCategory"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	occupationCategory: OccupationCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const OccupationCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	occupationCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleOccupationCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await occupationCategoryDeleteApi({ id: occupationCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [occupationCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete OccupationCategory: ${occupationCategory.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleOccupationCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
